import React, { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// assets
import removeIcon from "bodycodi/cmap/app/img/remove.png";

// utils
import { isEmpty, getYoutubeUrl } from "bodycodi/cmap/app/js/common";

// utils
import { api } from "bodycodi/cmap/app/js/api";

const AddVideoLink = ({
  open,
  setOpenAddLink,
  videoLinks,
  setVideoLinks,
  linkToEdit = "",
  setLinkToEdit,
}: any) => {
  const { seqPartnerCoach } = useSelector((state: RootState) => state.partner);
  const { dispatch } = useContext(DispatchContext);
  const [link, setLink] = useState<string>(linkToEdit);

  useEffect(() => {
    setLink(linkToEdit);
  }, [linkToEdit]);

  const handleKeyUp = (e: any) => {
    if (!link) return null;
    if (e.keyCode === 13) {
      addLink();
    }
  };

  const addLink = () => {
    if (
      !(
        link.startsWith("https://youtu.be") ||
        link.startsWith("https://www.youtube.com") ||
        link.startsWith("https://m.youtube.com")
      )
    ) {
      dispatch({
        type: "UPDATE",
        data: { toast1: true, toastText: "YouTube 링크 주소를 다시 확인해 주세요." },
      });
      return null;
    }

    uploadLinkRequest();
  };

  const uploadLinkRequest = async () => {
    try {
      await api
        .post("/community/link/upload", {
          seqPartnerCoach,
          link: getYoutubeUrl(link),
        })
        .then(({ data }) => {
          // if link's edit button is clicked
          if (!isEmpty(linkToEdit)) {
            const newLinks = videoLinks.map((item: any) => {
              if (item.link === linkToEdit) {
                return { fileId: data.fileId, link: data.link };
              }
              return item;
            });
            setVideoLinks(newLinks);
          } else {
            // if link already exists inside a link
            if (videoLinks.findIndex((item: any) => item.link === link) >= 0) {
              setOpenAddLink(false);
              setLink("");
              return null;
            }
            setVideoLinks([...videoLinks, { fileId: data.fileId, link: data.link }]);
          }
          setOpenAddLink(false);
          setLinkToEdit("");
          setLink("");
        });
    } catch (error) {
      console.error(error);
    }
  };

  const handleRemove = () => {
    setLink("");
  };

  if (!open) return null;
  else
    return (
      <div className="add-link-wrap">
        <div className="add-link">
          <input
            type="text"
            placeholder="YouTube 링크를 입력해주세요."
            onKeyUp={handleKeyUp}
            value={link}
            onChange={(e: any) => setLink(e.target.value)}
            autoFocus={true}
            maxLength={100}
          />
          {!!link.length && <img className="remove" src={removeIcon} onClick={handleRemove} />}
        </div>
        <button className="confirm-button" disabled={link.length === 0} onClick={addLink}>
          확인
        </button>
      </div>
    );
};

export default AddVideoLink;
